export default class StringService {
  static dateTimestampToString = (timestamp) => {
    const newDate = new Date(timestamp * 1000);
    const mm = newDate.getMonth() + 1; // getMonth() is zero-based
    const dd = newDate.getDate();
    return newDate.getFullYear()+'-'+(mm>9 ? '' : '0') + mm+'-'+(dd>9 ? '' : '0') + dd;
  };

  static timeTimestampToString = (timestamp) => {
    const newDate = new Date(timestamp * 1000);
    const hh = newDate.getHours();
    const mm = newDate.getMinutes();
    const ss = newDate.getSeconds();
    return (hh>9 ? '' : '0')+hh+':'+(mm>9 ? '' : '0')+mm+':'+(ss>9 ? '' : '0')+ss;
  };

  static dayTimestampToString = (timestamp) => {
    const newDate = new Date(timestamp * 1000);
    const day = newDate.getDay();
    let weekday = new Array(7);
    weekday[0] =  "Dimanche";
    weekday[1] = "Lundi";
    weekday[2] = "Mardi";
    weekday[3] = "Mercredi";
    weekday[4] = "Jeudi";
    weekday[5] = "Vendredi";
    weekday[6] = "Samedi";
    return weekday[day];
  };

  static dateStringToTimestamp = (date) => {
    const splitDate=date.split("-");
    return Math.floor(new Date(splitDate).getTime() / 1000)
  };

  static dateTimeStringToTimestamp = (date) => {
    const split=date.split("T");
    const splitDate=split[0].split("-");
    splitDate[1] --;
    const splitTime=split[1].split(":");
    return Math.floor(new Date(...splitDate.concat(splitTime)).getTime() / 1000)
  };

  static formatClientName(lastname, firstname) {
    let result  ='';
    if (lastname !== undefined && lastname !== null && lastname !== "") {
      result = lastname.toUpperCase();
    }
    if (firstname !== undefined && firstname !== null && firstname !== "") {
      if (result !== '') {
        result = result + ' ';
      }
      result = result + firstname;
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./src/services/StringService.js